import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';

@JsonObject('ClientSearchParams')
export class ClientSearchParams extends SearchParams {
    @JsonProperty('is_approved', Boolean, true)
    isApproved = true;

    @JsonProperty('get_services', Boolean, true)
    getServices = null;
}
